import { Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { Icon } from '../../../elementsv2'
import { match } from 'ts-pattern'
import { Zap, ZapOff } from 'lucide-react'

type Props = { className?: string; alwaysAlive?: boolean; pending?: boolean }

export const AlwaysAliveBadge = ({ alwaysAlive = false, pending = false, ...props }: Props) => {
  return (
    <Tooltip>
      <TooltipContent>{alwaysAlive ? 'Always alive' : 'Not always alive'}</TooltipContent>
      <TooltipTrigger {...props}>
        {match({ alwaysAlive, pending })
          .with({ pending: true, alwaysAlive: false }, () => (
            <Icon variant="soft" muted className="animate-pulse" icon={Zap} />
          ))
          .with({ pending: true, alwaysAlive: true }, () => (
            <Icon variant="soft" color="gray" muted className="animate-pulse" icon={ZapOff} />
          ))
          .with({ alwaysAlive: true }, () => <Icon variant="soft" icon={Zap} />)
          .with({ alwaysAlive: false }, () => <Icon icon={ZapOff} padding muted color="gray" />)
          .exhaustive()}
      </TooltipTrigger>
    </Tooltip>
  )
}
